import Model from "~/models/_Model";
import Task from "./Task";
import dayjs from "dayjs";

export default class Schedule extends Model {
  // Define a base url for a REST API
  baseURL() {
    return super.baseURL() + "/systemsmanager";
  }

  // Set the resource route of the model
  resource() {
    return "schedules";
  }

  relations() {
    return {
      task: Task,
    };
  }

  getOptionsInEnglish() {
    if (!this.options) {
      return [];
    }
    return this.options.map((option) => {
      return dayjs().day(option).format("ddd");
    });
  }

  get description() {
    let append_exceptions = "";
    if (this.options && this.options.length > 0) {
      append_exceptions = ` except ${this.getOptionsInEnglish().join(", ")}`;
    }

    return `Every ${this.intervals} ${this.frequency}${append_exceptions}.`;
  }
}
